import axios, { baseUrl } from './axios';
import queryString from 'query-string';

export default {
  loadPositionList: async (options = {}) => {
    const params = queryString.stringify(
      Object.assign(
        { offset: options.offset, limit: options.limit },
        options.filter,
      ),
    );
    if (options.organisationId) {
      const result = await axios.get(
        `${baseUrl}/customer/mob/organisations/${
          options.organisationId
        }/positions${params ? `?${params}` : ''}`,
      );
      return result.data;
    }
  },
  adddPosition: async (options = {}) => {
    const result = await axios.post(
      `${baseUrl}/customer/mob/organisations/${
        options.organisationId
      }/positions`,
      options.data,
    );
    return result.data;
  },
  updatePosition: async (options = {}) => {
    const result = await axios.put(
      `${baseUrl}/customer/mob/organisations/${
        options.organisationId
      }/positions`,
      options.data,
    );
    return result.data;
  },
  deletePosition: async (options = {}) => {
    const result = await axios.delete(
      `${baseUrl}/customer/mob/organisations/${
        options.organisationId
      }/positions/${options.id}`,
    );
    return result.data;
  },
};
